/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Checkout_Payment_Qr_Title1Inputs */

const vi_sitesettings_checkout_payment_qr_title1 = /** @type {(inputs: Sitesettings_Checkout_Payment_Qr_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên cách chuyển khoản QR`)
};

/**

* @param {Sitesettings_Checkout_Payment_Qr_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_checkout_payment_qr_title1 = /** @type {((inputs?: Sitesettings_Checkout_Payment_Qr_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Checkout_Payment_Qr_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_checkout_payment_qr_title1(inputs)
});
export { sitesettings_checkout_payment_qr_title1 as "siteSettings_checkout_payment_qr_title" }